var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"word",class:{ selected: _vm.selectedWord, parent: _vm.parent, child: _vm.child },on:{"mouseenter":_vm.onEnter,"mouseleave":_vm.onLeave}},[_vm._v(_vm._s(_vm.word.value))])}
var staticRenderFns = []

export { render, staticRenderFns }